import { render, staticRenderFns } from "./LaoSantipap.vue?vue&type=template&id=b114ebda&"
import script from "./LaoSantipap.vue?vue&type=script&lang=js&"
export * from "./LaoSantipap.vue?vue&type=script&lang=js&"
import style0 from "./LaoSantipap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports